import React from 'react'
import { StyledSearchingBookmarkSaveModal } from './styled'
import { API } from 'javascripts/api'
import { PostSearchingBookmark } from 'javascripts/api/generated/api'
import { FormProvider, useForm } from 'react-hook-form'
import { MemberLayoutContext } from 'spa/member/layouts/MemberLayout/Index'

type Props = PostSearchingBookmark & {
  setIsModalOpenFalse: () => void;
}

const Index: React.FC<Props> = (props: Props) => {
  const { setFlash } = React.useContext(MemberLayoutContext)
  const methods = useForm<PostSearchingBookmark>(
    {
      defaultValues: {
        name: '',
        word: props.word,
        minPrice: props.minPrice,
        maxPrice: props.maxPrice,
        workingDays: props.workingDays,
        workStyles: props.workStyles,
        categoryIds: props.categoryIds,
        prefectureIds: props.prefectureIds,
        skillIds: props.skillIds,
        appealIds: props.appealIds
      }
    }
  )
  // TODO: 以下を表示するには、レイアウトにフラッシュメッセージを追加する必要がある
  const onSubmit = (payload: PostSearchingBookmark) => {
    void API.createUserSearchingBookmark(payload).then(response => {
      props.setIsModalOpenFalse()
      setFlash({ success: response.data.message })
    }).catch(error => {
      if (API.isAxiosError(error) && API.isUnprocessableEntityError(error.response)) {
        props.setIsModalOpenFalse()
        setFlash({ error: error.response.data.message })
      }
    })
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <StyledSearchingBookmarkSaveModal
          onClose={props.setIsModalOpenFalse}
        />
      </form>
    </FormProvider>
  )
}

export default Index
